import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import '../src/assets/css/common.scss'

Vue.config.productionTip = false
Vue.use(ElementUI);
router.beforeEach((to,from,next)=>{
// 判断是否是手机端，如果是，返回true
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|ipad)/i)
  // Macintosh
  console.log(flag,'flag')
  if(flag){
    //路径是否包含phone，不包含跳转手机端首页，包含直接放过
    if (to.fullPath.toLowerCase().indexOf('phone') == -1) {
      next('/phone')
    } else {
      next()
    }
  }else {
    if (to.fullPath.toLowerCase().indexOf('phone') != -1) {
      next('/')
    }
    next();
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
